import { render, staticRenderFns } from "./OptionGroup.vue?vue&type=template&id=d0faca2a&"
import script from "./OptionGroup.vue?vue&type=script&lang=js&"
export * from "./OptionGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports